import React, { useState } from 'react';
import { Mail, Phone, UserIcon, BuildingIcon, CheckCircle2 } from 'lucide-react';
export function ContactB2B() {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [sent, setSent] = useState(false);
  const [touched, setTouched] = useState(false);
  const errors = {
    nombre: formData.nombre.trim().length < 2 ? 'Ingresa tu nombre' : '',
    empresa: formData.empresa.trim().length < 2 ? 'Ingresa tu empresa' : '',
    email: formData.email.trim().length === 0 ? 'Ingresa tu correo' : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(formData.email.trim()) ? 'Correo inválido' : '',
    telefono: formData.telefono.trim().length < 8 ? 'Ingresa tu teléfono' : ''
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    const hasSyncErrors = Object.values(errors).some(Boolean);
    if (hasSyncErrors) return;
    // Dispatch event para tracking
    window.dispatchEvent(new CustomEvent('b2b-contact-submit', {
      detail: {
        ...formData,
        type: 'b2b-contact',
        ts: new Date().toISOString()
      }
    }));
    setSent(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  if (sent) {
    return <section id="contacto-b2b" className="py-16 md:py-24 bg-gradient-to-b from-[#F8FAFC] to-white" data-id="element-728">
        <div className="container mx-auto max-w-3xl px-4" data-id="element-729">
          <div className="text-center bg-white rounded-2xl p-12 shadow-lg border border-gray-100" data-id="element-730">
            <div className="mb-6 flex justify-center" data-id="element-731">
              <div className="rounded-full bg-green-100 p-4" data-id="element-732">
                <CheckCircle2 className="h-12 w-12 text-green-600" data-id="element-733" />
              </div>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628] mb-4" data-id="element-734">
              ¡Gracias, {formData.nombre}!
            </h3>
            <p className="text-lg text-[#6B7280] mb-2" data-id="element-735">
              Nos pondremos en contacto contigo en las próximas 24 horas.
            </p>
            <p className="text-sm text-[#6B7280]" data-id="element-736">
              Te escribiremos a <strong data-id="element-737">{formData.email}</strong>
            </p>
          </div>
        </div>
      </section>;
  }
  return <section id="contacto-b2b" className="py-16 md:py-24 bg-gradient-to-b from-[#F8FAFC] to-white" data-id="element-738">
      <div className="container mx-auto max-w-4xl px-4" data-id="element-739">
        <div className="text-center mb-12" data-id="element-740">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4" data-id="element-741">
            Únete a Creditual como partner
          </h2>
          <p className="text-lg text-[#6B7280]" data-id="element-742">
            Completa el formulario y te contactaremos en menos de 24 horas
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-gray-100" data-id="element-743">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-744">
            {/* Nombre */}
            <div data-id="element-745">
              <label className="block text-sm font-semibold text-[#0A1628] mb-2" data-id="element-746">
                Nombre completo *
              </label>
              <div className="relative" data-id="element-747">
                <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-748" />
                <input required type="text" name="nombre" className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all" placeholder="Tu nombre y apellido" value={formData.nombre} onChange={handleChange} onBlur={() => setTouched(true)} data-id="element-749" />
              </div>
              {touched && errors.nombre && <p className="mt-1 text-xs text-red-600" data-id="element-750">{errors.nombre}</p>}
            </div>

            {/* Empresa */}
            <div data-id="element-751">
              <label className="block text-sm font-semibold text-[#0A1628] mb-2" data-id="element-752">
                Empresa o inmobiliaria *
              </label>
              <div className="relative" data-id="element-753">
                <BuildingIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-754" />
                <input required type="text" name="empresa" className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all" placeholder="Nombre de tu empresa" value={formData.empresa} onChange={handleChange} onBlur={() => setTouched(true)} data-id="element-755" />
              </div>
              {touched && errors.empresa && <p className="mt-1 text-xs text-red-600" data-id="element-756">{errors.empresa}</p>}
            </div>

            {/* Email y Teléfono en grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-757">
              {/* Email */}
              <div data-id="element-758">
                <label className="block text-sm font-semibold text-[#0A1628] mb-2" data-id="element-759">
                  Correo electrónico *
                </label>
                <div className="relative" data-id="element-760">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-761" />
                  <input required type="email" name="email" className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all" placeholder="tu@correo.cl" value={formData.email} onChange={handleChange} onBlur={() => setTouched(true)} data-id="element-762" />
                </div>
                {touched && errors.email && <p className="mt-1 text-xs text-red-600" data-id="element-763">{errors.email}</p>}
              </div>

              {/* Teléfono */}
              <div data-id="element-764">
                <label className="block text-sm font-semibold text-[#0A1628] mb-2" data-id="element-765">
                  Teléfono *
                </label>
                <div className="relative" data-id="element-766">
                  <Phone className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-767" />
                  <input required type="tel" name="telefono" className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all" placeholder="+56 9 1234 5678" value={formData.telefono} onChange={handleChange} onBlur={() => setTouched(true)} data-id="element-768" />
                </div>
                {touched && errors.telefono && <p className="mt-1 text-xs text-red-600" data-id="element-769">{errors.telefono}</p>}
              </div>
            </div>

            {/* Mensaje */}
            <div data-id="element-770">
              <label className="block text-sm font-semibold text-[#0A1628] mb-2" data-id="element-771">
                Mensaje (opcional)
              </label>
              <textarea name="mensaje" rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all resize-none" placeholder="Cuéntanos sobre tu empresa y cómo podemos ayudarte..." value={formData.mensaje} onChange={handleChange} data-id="element-772" />
            </div>

            {/* Submit */}
            <button type="submit" className="w-full px-8 py-4 bg-gradient-to-r from-[#2B5FD9] to-[#1E4BB8] text-white text-lg font-semibold rounded-xl hover:shadow-xl hover:-translate-y-1 transition-all" onClick={() => setTouched(true)} data-id="element-773">
              Quiero ser partner de Creditual
            </button>

            <p className="text-xs text-center text-[#6B7280]" data-id="element-774">
              Al enviar este formulario, aceptas nuestros{' '}
              <a href="/terminos" className="text-[#2B5FD9] hover:underline" data-id="element-775">
                términos y condiciones
              </a>
            </p>
          </form>
        </div>
      </div>
    </section>;
}